module.exports = __webpack_public_path__ + "img/mobileadminBanner.816c7373.png";